import React, { useState, useEffect, createContext } from 'react';

/**
 * Context pentru tema dark/light.  Iniţial setează tema
 * implicit pe „dark”. Preferinţa este salvată în localStorage.
 */
const ThemeContext = createContext({
  theme: 'dark',
  toggleTheme: () => {}
});

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark');

  // La montare, determină tema iniţială din localStorage,
  // altfel păstrează modul "dark" ca implicit.
  useEffect(() => {
    const stored = localStorage.getItem('theme');
    if (stored) {
      setTheme(stored);
    } else {
      setTheme('dark');
    }
  }, []);

  // Aplică clasa pe elementul html pentru a activa modul dark
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;